import React from "react";
import { Power, GripVertical } from "lucide-react";
import s from "../../pages/ProductionSuite.module.css";

/**
 * Mixer + FX chain bottom panel for the Production Suite.
 * Pure UI state — actual audio routing is out of scope this iteration.
 */
export function PSMixer({ tracks, volumes, setVolume }) {
  const startDrag = (e, trackId) => {
    e.preventDefault();
    const rect = e.currentTarget.getBoundingClientRect();
    const startY = e.clientY;
    const startVol = volumes[trackId] || 0;
    const handle = (ev) => {
      const dy = startY - ev.clientY;
      const next = Math.max(0, Math.min(100, startVol + (dy / rect.height) * 100));
      setVolume(trackId, Math.round(next));
    };
    const stop = () => {
      document.removeEventListener("mousemove", handle);
      document.removeEventListener("mouseup", stop);
    };
    document.addEventListener("mousemove", handle);
    document.addEventListener("mouseup", stop);
  };

  const stripsList = [
    ...tracks.map((t) => ({ ...t, isMaster: false })),
    { id: "master", name: "Master", color: "#e2e4ea", isMaster: true },
  ];

  return (
    <div className={s.mixer} data-testid="ps-mixer">
      <div className={s.mixerHeader}>// MIXER</div>
      <div className={s.mixerStrips}>
        {stripsList.map((t) => {
          const vol = volumes[t.id] ?? 80;
          const db = Math.round((vol / 100) * 6 - 6);
          return (
            <div key={t.id} className={s.strip} data-testid={`ps-strip-${t.id}`}>
              <div className={s.knob} title="Pan (drag — UI only)" />
              <div
                className={s.faderTrack}
                onMouseDown={(e) => startDrag(e, t.id)}
                data-testid={`ps-fader-${t.id}`}
              >
                <div
                  className={s.faderFill}
                  style={{ height: `${vol}%`, background: t.color }}
                />
              </div>
              <div className={s.faderDb}>{db}dB</div>
              <div className={s.faderName}>{t.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}


export function PSFXChain({ selectedTrack, fx, toggleFx, addFx }) {
  const items = fx[selectedTrack?.id] || [];
  return (
    <div className={s.fxChain} data-testid="ps-fxchain">
      <div className={s.fxHeader}>
        // FX CHAIN — {selectedTrack?.name || "—"}
      </div>
      {items.map((f, idx) => (
        <div key={idx} className={s.fxSlot} data-testid={`ps-fx-${selectedTrack.id}-${idx}`}>
          <div className={s.fxDot} style={{ background: f.color }} />
          <div className={s.fxBody}>
            <div className={s.fxName}>{f.name}</div>
            <div className={s.fxValue}>{f.value}</div>
          </div>
          <button
            type="button"
            onClick={() => toggleFx(selectedTrack.id, idx)}
            className={`${s.fxToggle} ${f.enabled ? s.fxToggleOn : ""}`}
            title={f.enabled ? "On" : "Off"}
            data-testid={`ps-fx-toggle-${selectedTrack.id}-${idx}`}
          >
            <Power size={9} />
          </button>
        </div>
      ))}
      <div
        className={s.fxAddSlot}
        onClick={() => addFx(selectedTrack?.id)}
        data-testid={`ps-fx-add-${selectedTrack?.id}`}
      >
        <GripVertical size={11} style={{ display: "inline", verticalAlign: "middle" }} /> Add effect
      </div>
    </div>
  );
}
